import { useEffect } from "react"

const IMAGES_TO_PRELOAD = [
  // Forest template
  "/images/trees-blurry.jpg",
  // Umbrella template
  "/images/beach-horizon.jpg",
  "/images/umbrella.svg",
  "/images/boquet1.jpg",
  "/images/flower-menu.jpg",
  // Dandelion template
  "/images/dandelion.svg",
  // Main/shared decorative images
  "/images/buds-small.png",
  "/images/leaf-small.png",
  "/images/flower-1.png",
  "/images/flowers-hr.png",
]

export function usePreloadImages() {
  useEffect(() => {
    IMAGES_TO_PRELOAD.forEach((src) => {
      const img = new Image()
      img.src = src
    })
  }, [])
}
